import { useState } from "react"
import { toast } from "react-toastify"
import axiosInstance from "../../../services/axios-client"

const useProjectTotalSummary = () => {
    const [payload, setPayload] = useState()
    const [loadingPageState, setLoadingPage] = useState(false)
    const customOrder = {
        "A+": 6,
        "A": 5,
        "B+": 4,
        "B": 3,
        "C": 2,
        "D": 1,
        "":0,
    };

    const getAllSummary = async (id, projectID) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/projects/summary-calibration-total?projectID=${projectID}&calibratorID=${id}`)
            if (res.status === 200) {
                let finalData = res.data.data.Data
                finalData = finalData.sort((a, b) => customOrder[b.Rating] - customOrder[a.Rating]);   
                setPayload(finalData)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if(error.response){
                setPayload([])
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        }
    }

    return{
        payload,
        getAllSummary,
        loadingPageState
    }
}

export default useProjectTotalSummary